import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Gate for role-restricted routes. Wrap routes that require the signed-in user
 * to hold one of the allowed platform roles:
 *
 *   <Route element={<RoleRoute roles={['admin']} />}>
 *     <Route path="/academy-operations-console" element={<Console />} />
 *   </Route>
 *
 * Anonymous users are sent to /login (preserving intended destination); an
 * authenticated user without an allowed role is sent to /403.
 */
export default function RoleRoute({ roles = [] }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = String(user?.role || '').toLowerCase();
  if (roles.length && !roles.map((r) => r.toLowerCase()).includes(role)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
